module.exports = __webpack_public_path__ + "static/media/edit.030bf425.svg";